import React, { useContext, useEffect, useRef, useState } from "react";
import { SwipeableDrawer } from "@mui/material";
import { TodosContext } from "../providers/TodosProvider";
import { v4 as uuidv4 } from "uuid";
import { todosRef } from "../firebase";
import { AuthContext } from "../providers/AuthProvider";
import "../css/todos.scss";
import { dateTimeFormatter } from "../helperFunctions/dateFormatters";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import DeleteIcon from "@mui/icons-material/Delete";
import { todoers } from "../popData";
import { deleteDoc, doc, setDoc, updateDoc } from "firebase/firestore";

// const isTouchDevice = () => {
//   return (('ontouchstart' in window) ||
//     (navigator.maxTouchPoints > 0) ||
//     (navigator.msMaxTouchPoints > 0));
// }
// console.log(isTouchDevice())

// const ADD_TODO = "ADD_TODO";
// const CLEAR_TODOS = "CLEAR_TODOS";

// function todoReducer(state, action) {
//   switch (action.type) {
//     case "ADD_TODO": {
//       console.log("In add todo reducer");
//       return [...state];
//     }
//     default:
//       console.log("in todo reducer, default clause");
//       return [...state];
//   }
// }
// const [todoForm, dispatch] = useReducer(todoReducer, todos);

const generalReminderUid = "63537b3b-a0ec-462c-b0e4-cf4f5b453939";

const TodoItem = (props) => {
  let { uid, intendedFor, primaryText, isComplete, created } = props.todo;
  const todoElRef = useRef(null);
  const [showBin, setShowBin] = useState(false);

  // Need a local complete to solve issues with animation and state changes
  // when toggling todos
  const [localComplete, setLocalComplete] = useState(isComplete);

  async function deleteTodo(todoUid) {
    // Removes todo
    try {
      deleteDoc(doc(todosRef, todoUid));
    } catch (e) {
      console.log("Error deleting todo", e);
    }
  }

  async function toggleTodoComplete(e) {
    try {
      // Need to use ref to apply state change only after animation has occurred

      if (!isComplete) {
        // todo being marked as complete
        setLocalComplete(true);
        todoElRef.current.classList.add("being-marked");
      } else if (isComplete) {
        // todo being marked as not complete
        setLocalComplete(false);
        todoElRef.current.classList.add("being-unmarked");
      }

      // Wait for animation to end before applying update to db
      todoElRef.current.onanimationend = async () => {
        let markedCompletedOn = isComplete ? "" : Date.now();

        await updateDoc(doc(todosRef, uid), {
          isComplete: !isComplete,
          markedCompletedOn,
        });
      };
    } catch (err) {
      console.log("caught todo toggled.", err);
    }
  }

  // function openDetailedView(e) {
  //   e.stopPropagation();
  //   console.log("Still need to do, open detailed view of the todo");
  // }

  return (
    <div
      ref={todoElRef}
      className={`todo-item ${isComplete ? "is-marked" : ""}`}
      key={uid}
      onMouseEnter={(e) => {
        setShowBin(true);
      }}
      onMouseLeave={(e) => {
        setShowBin(false);
      }}
    >
      <button
        // onClick={openDetailedView}
        onClick={() => deleteTodo(uid)}
        style={{ background: todoers[intendedFor]?.colourStyle ?? "yellow" }}
        className="intended-for"
        id="intended-for"
      >
        {isComplete && showBin ? (
          <DeleteIcon />
        ) : (
          todoers[intendedFor]?.initials ?? "??"
        )}
      </button>

      <div className="todo-main-body">
        <p className="date-added">{dateTimeFormatter(created, "dt_short")}</p>
        <p className="primary-text">{primaryText}</p>
      </div>
      {/* <p>{secondaryText}</p> */}

      <button className="todo-check-btn" onClick={toggleTodoComplete}>
        {localComplete ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
      </button>
      {/* <button onClick={() => toggleTodoComplete("bye")}>
        {isComplete ? "no" : "yes"}
      </button> */}
      {/* <input
        type="checkbox"
        ref={checkElRef}
        checked={isComplete}
        className="todo-check-box"
        onChange={toggleTodoComplete}
      /> */}
      {/* added at {dateTimeFormatter(created, "dt_full")} */}
    </div>
  );
};

export const TodoForm = ({ todos }) => {
  const auth = useContext(AuthContext);
  // const { timesheets, loading } = useContext(TimesheetsContext);

  // const [primaryToSearch, setPrimaryToSearch] = useState("");
  const [todoForm, setTodoForm] = useState({
    intendedFor: generalReminderUid,
    isComplete: false,
    // primaryText: "Primary text: Your goal is to do as I say",
    // secondaryText: "Extra information will be placed inside here.",
  });

  // async function clearAll() {
  //   // remove all todos, dev mode
  //   try {
  //     console.log("todos", todos);
  //     todos.map(async (t) => {
  //       todosRef.doc(t.uid).delete();
  //     });
  //   } catch (e) {
  //     console.log("Error adding todo", e);
  //   }
  // }

  async function addTodo() {
    // need to move this into either the todosProvider or its own hook
    const primaryId = uuidv4();

    try {
      let { intendedFor, primaryText = "", secondaryText = "" } = todoForm;

      await setDoc(doc(todosRef, `${primaryId}`), {
        uid: primaryId,
        intendedFor: intendedFor, //todoers[intendedFor]?.initials || "??",
        createdBy: auth.user.uid,
        created: Date.now(),
        markedCompletedOn: "",
        isComplete: false,
        // colourStyle: todoers[intendedFor]?.colourStyle || "darkgrey",
        primaryText: primaryText,
        secondaryText: secondaryText,
      });

      // toggleFilters(null, "intendedFor", intendedFor);

      setTodoForm({
        intendedFor: generalReminderUid,
      });
    } catch (e) {
      console.log("Error adding todo", e);
    }
  }

  function handleInput(e) {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "isCompleted") {
      value = e.target.checked;
    }

    setTodoForm({ ...todoForm, [name]: value });
  }

  // function searchPrimaries() {
  // This will be used to search for primaries through highlighting
  // the text. Not yet sure how to apply it once primary found or whether
  // let highlighted = window.getSelection().toString();
  // console.log("highlighted", highlighted);

  // let searched = filterPrimaries(timesheets, { searchTerm: highlighted });
  // console.log("timesheets", searched);
  // }

  return (
    <div className="todo-form">
      {/* <h3>Todo Form</h3> */}
      <textarea
        placeholder="Reminder"
        rows={4}
        type="text"
        id="primaryText"
        name="primaryText"
        value={todoForm?.primaryText ?? ""}
        onChange={handleInput}
      />
      {/* <input
        placeholder="extra"
        type="text"
        id="secondaryText"
        name="secondaryText"
        value={todoForm?.secondaryText ?? ""}
        onChange={handleInput}
      /> */}

      <div className="todo-form-controls">
        <select
          name="intendedFor"
          id="intendedFor"
          onChange={handleInput}
          value={todoForm?.intendedFor}
        >
          {Object.keys(todoers).map((todoerId) => {
            // console.log("todoerId", todoerId);
            let { uid, name } = todoers[todoerId];
            return (
              <option key={uid} value={uid}>
                {name}
              </option>
            );
          })}
        </select>

        <div className="todo-form-btn-group">
          {/* <button onClick={searchPrimaries} className="todo-add-btn">
            Search
          </button> */}
          <button
            className="todo-add-btn"
            onClick={() => {
              // add a todo to the db
              addTodo();
            }}
          >
            Add
          </button>

          {/* <button className="todo-clear-btn" onClick={clearAll}>
            clear
          </button> */}
        </div>
      </div>
    </div>
  );
};

// Needs to be stringified to play nice with session storage
let defaultFilters = JSON.stringify({
  intendedFor: [],
  orderBy: [],
  status: [],
});

const TodosContainer = (props) => {
  const { todos, toggleTodosDrawer } = useContext(TodosContext);
  // const [keyPress, setKeyPress] = useState(false);

  const [filters, setFilters] = useState(
    JSON.parse(
      window?.sessionStorage?.getItem("todo-filters") || defaultFilters
    )
  );

  const filteredTodos = filterTodos(todos);

  function filterTodos(todos) {
    // Filter todos by filters present (only intended for works atm)

    // Loop through filter keys
    let filteredData = [...todos];
    Object.keys(filters).forEach((filter) => {
      filteredData = filteredData.filter((todo) => {
        if (filters[filter]?.length === 0) {
          return true;
        }

        return filters[filter].includes(todo[filter]);
      });
    });

    return filteredData;
  }

  function toggleFilter(e, filterKey, filterLabel) {
    // Is filter in filters already?
    let isFilter = filters[filterKey].includes(filterLabel);
    let tempFilters = [...filters[filterKey]];
    let alteredFilters = [];

    if (props.shiftHeld) {
      // If shift key being held.
      // Allows multiple filters to be placed

      // Remove or Add filter to filters
      if (isFilter) {
        // remove filter
        alteredFilters = tempFilters.filter((f) => {
          return f !== filterLabel;
        });
      } else {
        // add filter
        alteredFilters = [...tempFilters, filterLabel];
      }
    } else {
      // If shift key is not being pressed, allow
      // only one filter to be placed
      if (isFilter) {
        // remove filter
        alteredFilters = tempFilters.filter((f) => {
          return f !== filterLabel;
        });
      } else {
        // add filter
        alteredFilters = [filterLabel];
      }
    }

    // Set filters in session storage and local state
    window.sessionStorage.setItem(
      "todo-filters",
      JSON.stringify({
        ...filters,
        [filterKey]: alteredFilters,
      })
    );

    setFilters({
      ...filters,
      [filterKey]: alteredFilters,
    });
  }

  function clearFilters() {
    // Clear todo filters from session storage and state
    window.sessionStorage.setItem(
      "todo-filters",
      JSON.stringify({
        intendedFor: [],
        orderBy: [],
        status: [],
      })
    );

    setFilters({
      intendedFor: [],
      orderBy: [],
      status: [],
    });
  }

  return (
    <div className="todos-container">
      <div className="todo-header">
        <TodoForm todos={todos} />
        <button
          onClick={() => toggleTodosDrawer(false)}
          className="close-todos"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="todos-filter-bar">
        {/* Filter controls will go here */}
        <div className="todo-intended-for-filters">
          {Object.keys(todoers).map((todoerUid, i) => {
            let { uid, initials } = todoers[todoerUid];
            let isFilter = filters["intendedFor"].includes(uid);

            return (
              <button
                onClick={(e) => toggleFilter(e, "intendedFor", uid)}
                data-filter={isFilter ? "active" : "inactive"}
                // style={{ borderColor: colourStyle, color: colourStyle }}
                className="intended-for-filter-btn"
                key={uid}
              >
                {initials}
              </button>
            );
          })}
        </div>

        <div className="todo-status-filters">
          <button onClick={clearFilters} className="completed-filter-btn">
            x
          </button>
        </div>
      </div>

      <div className="todos-list">
        {filteredTodos?.map((todo, i) => {
          // console.log("TODO", todo);
          return <TodoItem todo={todo} key={todo.uid} />;
        })}
      </div>
    </div>
  );
};

const TodosDrawer = (props) => {
  const [keyPress, setKeyPress] = useState(true);

  useEffect(() => {
    // Add key down and up listeners to listen for shift key pres
    // Holding shift alters the behaviour when clicking todo filters

    let keyDownEvent = document.addEventListener("keydown", (e) => {
      if (e.key === "Shift") {
        setKeyPress(true);
      }
    });

    let keyUpEvent = document.addEventListener("keyup", (e) => {
      setKeyPress(false);
    });

    return () => {
      document.removeEventListener("keydown", keyDownEvent);
      document.removeEventListener("keyup", keyUpEvent);
    };
  }, []);

  return (
    <div>
      <SwipeableDrawer
        anchor="right"
        open={props.todosDrawer}
        onClose={props.toggleTodos(false)}
        onOpen={props.toggleTodos(true)}
        disableDiscovery={true}
        disableSwipeToOpen={true}
      >
        <TodosContainer shiftHeld={keyPress} />
      </SwipeableDrawer>
      {/* <button onClick={() => setTodosDrawer(!todosDrawer)}>toggle</button> */}
    </div>
  );
};

export default TodosDrawer;
